export interface AgentStatus {
    dns_status?: AgentDnsStatus;
    general_status?: AgentGeneralStatuses;
    last_heartbeat?: Date;
    uptime?: number
}

export enum AgentGeneralStatuses {
    NEVER_DEPLOYED = 'NEVER_DEPLOYED', ONLINE = 'ONLINE', OFFLINE = 'OFFLINE'
}

export const AgentStatusDisplayString: { [key in AgentGeneralStatuses] : string } = {
  [AgentGeneralStatuses.ONLINE]: 'Online',
  [AgentGeneralStatuses.OFFLINE]: 'Offline',
  [AgentGeneralStatuses.NEVER_DEPLOYED]: 'Pending',
};

export interface AgentDnsStatus {
    agent: boolean
    broker: boolean
    google: boolean
}
